import { ThemeConfig, ThemeName } from '@/types/theme';

export const themes: Record<ThemeName, ThemeConfig> = {
  default: {
    name: 'default',
    colors: {
      primary: '#000000',
      secondary: '#D60B52',
      tertiary: '#000000',
      primaryLight: '#f0f0f0',
      background: '#f0f0f0',
      foreground: '#f0f0f0',
      text: '#000000',
      textSecondary: '#666666',
      border: '#e0e0e0',
      error: '#ef4444',
      success: '#10b981',
      disabled: '#d1d5db',
      disabledText: '#6b7280',
    },
    fonts: {
      primary: 'Hanken, sans-serif',
      secondary: 'Ubuntu, sans-serif',
    },
    spacing: {
      base: '0.25rem', // 4px
      small: '0.5rem', // 8px
      medium: '1rem', // 16px
      large: '1.5rem', // 24px
      xlarge: '2rem', // 32px
    },
    borderRadius: {
      small: '0.25rem', // 4px
      medium: '0.5rem', // 8px
      large: '0.75rem', // 12px
      xlarge: '1rem', // 16px
    },
  },
  zapay: {
    name: 'zapay',
    colors: {
      primary: '#FF0060',
      primaryLight: '#ffe6f0',
      secondary: '#ff4d8a',
      tertiary: '#666666',
      background: '#FFF',
      foreground: '#F0F0F0',
      text: '#000000',
      textSecondary: '#666666',
      border: '#e0e0e0',
      error: '#ff3333',
      success: '#00d4aa',
      disabled: '#d1d5db',
      disabledText: '#6b7280',
    },
    fonts: {
      primary: 'Inter, sans-serif',
      secondary: 'Inter, sans-serif',
    },
    spacing: {
      base: '0.25rem',
      small: '0.5rem',
      medium: '1rem',
      large: '1.75rem', // 28px
      xlarge: '2.5rem', // 40px
    },
    borderRadius: {
      small: '0.5rem', // 8px
      medium: '2rem', // 16px
      large: '1.5rem', // 24px
      xlarge: '2rem', // 32px
    },
  },
};

export const getTheme = (themeName: ThemeName): ThemeConfig => {
  return themes[themeName] || themes.default;
};
